import React from 'react'
import { usePostNotFound, PostNotFoundProps } from './usePostNotFound'

const PostNotFound: React.FC<PostNotFoundProps> = (
  props: PostNotFoundProps
) => {
  const { message } = usePostNotFound(props)

  return (
    <div className='container py-5'>
      <section>
        <div className='row'>
          <div className='col-12 text-center fs-4 fw-bold'>{message}</div>
        </div>
      </section>
    </div>
  )
}

export default PostNotFound
